import Styles from "../styles/BreadCrumb.module.css";
import Link from "next/link";

const BreadCrumb = ({ PageName, PartentPage, PartentURL, ChildName, ChildURL, CurrentPage, backgroundColor, TextShow, Textcontent ,isDashboard,isTab=false}) => {
    return (
        <div className={`${isTab ? "" : Styles.breadcrumb} py-0 py-md-5`} style={{  backgroundColor: backgroundColor, paddingTop:"80px" }}>
            <div className="container">
                {/* Breadcrumb Navigation */}
                <nav aria-label="breadcrumb" className="mb-3">
                    <ol className="breadcrumb mb-0 d-flex align-items-center">
                        <li className="breadcrumb-item breaditem ">
                            <Link href={PartentURL} className="text-muted small breadcrumb_link">
                                {PartentPage}
                            </Link>
                        </li>
                        {ChildName && ChildURL && (
                            <li className="breadcrumb-item breaditem">
                                <Link href={ChildURL} className="text-muted small breadcrumb_link">
                                    {ChildName}
                                </Link>
                            </li>
                        )}
                        <li className="breadcrumb-item breaditem active" aria-current="page">
                            {CurrentPage}
                        </li>
                    </ol>
                </nav>

                {/* Page Title */}
                <div className="d-flex justify-content-between mobilealigncenter">
                    {isDashboard?(  <h1 className="heading-2">{PageName}</h1>):(  <h1 className="">{PageName}</h1>)}
                  
                    {TextShow && (
                        <div className="textshow me-0 me-md-5">
                            <p className="welcome-msg-p">{Textcontent}</p>
                        </div>
                    )}
                </div>
                
            </div>
        </div>
    );
};

export default BreadCrumb;

